const items = [
  "Calcolatore Parametrico Online",
  "Valutazioni Tecniche da ex Costruttore",
  "Vendita e Affitto Immobili",
  "25 Anni di Esperienza sul Territorio",
];

export default function Marquee() {
  const row = [...items, ...items];
  return (
    <div className="bg-[var(--gold)] text-[var(--ink)] py-3 overflow-hidden" data-testid="marquee-bar">
      <div className="asc-mq flex items-center gap-8 font-mono-lbl text-xs uppercase tracking-widest font-semibold">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-8">
            <span>{item}</span>
            <span aria-hidden="true">•</span>
          </span>
        ))}
      </div>
    </div>
  );
}
